package br.com.htms.inspeccaocampo.shared.ui.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp

/**
 * Prévia das informações antes de confirmar o salvamento/envio.
 */
@Composable
fun PreviaAntesSalvarDialog(
    titulo: String = "Prévia antes de salvar",
    linhas: List<Pair<String, String>>,
    confirmLabel: String = "Confirmar e salvar",
    onConfirmar: () -> Unit,
    onDismiss: () -> Unit
) {
    CenteredAppDialog(
        onDismissRequest = onDismiss,
        title = titulo,
        confirmLabel = confirmLabel,
        onConfirm = {
            onDismiss()
            onConfirmar()
        },
        dismissLabel = "Voltar a editar"
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .heightIn(max = 420.dp)
                .verticalScroll(rememberScrollState()),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(
                "Confira os dados abaixo. Ao confirmar, a inspeção será salva no aparelho e enviada ao servidor se houver conexão.",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
            linhas.forEach { (rotulo, valor) ->
                if (valor.isBlank()) return@forEach
                Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                    Text(rotulo, fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.labelMedium)
                    Text(valor, style = MaterialTheme.typography.bodyMedium)
                }
            }
            if (linhas.none { it.second.isNotBlank() }) {
                Text("Nenhum dado preenchido ainda.", style = MaterialTheme.typography.bodyMedium)
            }
        }
    }
}

@Composable
fun PreviaLinha(rotulo: String, valor: String) {
    if (valor.isBlank()) return
    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        Text("$rotulo:", fontWeight = FontWeight.SemiBold, modifier = Modifier.weight(0.35f))
        Text(valor, modifier = Modifier.weight(0.65f))
    }
}
